import { render, staticRenderFns } from "./CompanyBrand.vue?vue&type=template&id=84d9556e"
import script from "./CompanyBrand.vue?vue&type=script&lang=js"
export * from "./CompanyBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports